import { useEffect, useState } from 'react'
import { usePersona } from '@/features/business/hooks/usePersona'
import { useSelectedUserGroup } from '@/features/account/services/Business/hooks'
import { getShoppingForText } from '@/features/business/utils/getShoppingForText'
import { VisuallyHidden } from '@/features/shared/elements/VisuallyHidden'
import { typographyAttributes } from '@shipt/design-system-typography'

export const PersonaAnnouncer = () => {
  const { activeGroup } = usePersona()
  const { selectedUserGroupId } = useSelectedUserGroup()
  const [announcedGroupId, setAnnouncedGroupId] = useState(selectedUserGroupId)
  const [pendingMessage, setPendingMessage] = useState('')
  const [message, setMessage] = useState('')

  if (announcedGroupId !== selectedUserGroupId) {
    setAnnouncedGroupId(selectedUserGroupId)
    setPendingMessage(`Now shopping for ${getShoppingForText(activeGroup)}`)
  }

  // Screen readers drop live updates made while focus is moving, so we give it a second to settle before announcing the new message
  useEffect(() => {
    if (!pendingMessage) return
    const timer = setTimeout(() => setMessage(pendingMessage), 1000)
    return () => clearTimeout(timer)
  }, [pendingMessage])

  return (
    <VisuallyHidden role="status" {...typographyAttributes({ isPII: true })}>
      {message}
    </VisuallyHidden>
  )
}
